import React, { useEffect, useState } from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import "./OpalCoveragePerformanceVisual.css";
import { getAll } from "../../../localDB";

const OpalCoveragePerformanceVisual = () => {
    const [selectedCycle, setSelectedCycle] = useState("Cycle 1");

    const data = [
        { label: "COMPLIANCE", value: 70, sub: null, color: "#D32F2F" },
        { label: "CALL RATE", value: 60, sub: "215 / 360", color: "#D32F2F" },
        { label: "CALL REACH", value: 92, sub: "175 / 190", color: "#388E3C" },
        { label: "CALL FREQUENCY", value: 92, sub: "175 / 190", color: "#388E3C" },
    ];

    const cycles = ["Cycle 1", "Cycle 2", "Cycle 3", "Cycle 4"];

    const fetchCycles = async () => {
        try {
            const response = await getAll("Cycles");
            console.log(response);
        } catch (err) {

        }
    }

    useEffect(() => {

    }, []);

    return (
        <div className="chart-content">
            <Container fluid className="coverage-container">
                <div className="dropdown-section">
                    <Dropdown onSelect={(cycle) => setSelectedCycle(cycle)} align="end">
                        <Dropdown.Toggle>
                            {selectedCycle}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                            className="p-2 circle-menu"
                            popperConfig={{
                                strategy: "fixed", 
                                modifiers: [
                                    {
                                        name: "preventOverflow",
                                        options: {
                                            boundary: "viewport", 
                                        },
                                    },
                                ],
                            }}
                        >
                            {cycles.map((cycle, index) => (
                                <Dropdown.Item key={index} eventKey={cycle}>
                                    {cycle}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <Row className="text-center">
                    {data.map((item, index) => (
                        <Col key={index} className="coverage-item">
                            <div className="coverage-value" style={{ color: item.color }}>
                                {item.value}%
                            </div>
                            <div className="coverage-sub">{item.sub || "\u00A0"}</div>
                            <div className="coverage-label">{item.label}</div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default OpalCoveragePerformanceVisual;
